import axios from "axios";
import { useUserContext } from "../../../contexts/UserContext";

export default function ChargeStopRecurringModal({ open, charge, onClose, onStopped }) {
  const { getAuthHeaders } = useUserContext();

  if (!open || !charge) return null;

  const handleStop = async () => {
    const res = await axios.patch(
      `http://localhost:4000/charges/${charge._id}/stop`,
      {},
      { headers: getAuthHeaders() }
    );

    onStopped();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card danger">
        <h3>🛑 Arrêter la charge</h3>

        <p>
          La charge <strong>{charge.description}</strong> ne sera plus comptabilisée
          à partir de ce mois.
        </p>

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn-danger" onClick={handleStop}>
            Arrêter définitivement
          </button>
        </div>
      </div>
    </div>
  );
}